import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\DetachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/DetachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/detach-from/{place_id}'
*/
const DetachWikiContactToPlaceController = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DetachWikiContactToPlaceController.url(args, options),
    method: 'post',
})

DetachWikiContactToPlaceController.definition = {
    methods: ["post"],
    url: '/api/wiki-contact/{contact}/detach-from/{place_id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiContact\DetachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/DetachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/detach-from/{place_id}'
*/
DetachWikiContactToPlaceController.url = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            contact: args[0],
            place_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
        place_id: args.place_id,
    }

    return DetachWikiContactToPlaceController.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace('{place_id}', parsedArgs.place_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\DetachWikiContactToPlaceController::__invoke
* @see app/Http/Controllers/WikiContact/DetachWikiContactToPlaceController.php
* @route '/api/wiki-contact/{contact}/detach-from/{place_id}'
*/
DetachWikiContactToPlaceController.post = (args: { contact: string | { id: string }, place_id: string | number } | [contact: string | { id: string }, place_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DetachWikiContactToPlaceController.url(args, options),
    method: 'post',
})

export default DetachWikiContactToPlaceController